import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
import * as executorsActions from '../actions/executorsActions';
import { getAllExecutorsRequest } from '../../api/executors/getAllExecutorsRequest';
import { getFilterExecutorsRequest } from '../../api/executors/getFilterExecutorsRequest';
import { errorProcessing } from '../../../Employees/api/errorProcessing';
import history from '../../../../common/history';
//import showSuccessWindow from '../../../../common/components/successPopup/successPopup';
//import { successDeleteSelectedTemplates } from '../../components/TemplateCard/popup/success';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllExecutorsSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllExecutorsRequest, activeProfileId);
      let executorsTypes = {};
      let executorsStat = {};
      response.forEach(item => {
        if (!executorsTypes.hasOwnProperty(item.status)) {
          executorsTypes[item.status] = {
            key: item.status,
            status: item.status === 'active' ? 'Активные' : 'Неактивные',
          };
        }
        executorsStat.hasOwnProperty(item.status)
          ? executorsStat[item.status]++
          : (executorsStat[item.status] = 1);
      });
      yield put(
        executorsActions.getAllExecutorsSuccess({
          executorsTypes: Object.keys(executorsTypes).map(
            key => executorsTypes[key]
          ),
          executors: response,
          executorsStat,
        })
      );
    } catch (e) {
      yield put(executorsActions.getAllExecutorsFailure(errorProcessing(e)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(executorsActions.getAllExecutors(action.payload))
      : history.push('/authorization/profiles');
  }
}

function* getFilterExecutorsSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getFilterExecutorsRequest,
        activeProfileId,
        action.payload
      );
      let executorsTypes = {};
      let executorsStat = {};
      response.forEach(item => {
        if (!executorsTypes.hasOwnProperty(item.status)) {
          executorsTypes[item.status] = {
            key: item.status,
            status: item.status === 'active' ? 'Активные' : 'Неактивные',
          };
        }
        executorsStat.hasOwnProperty(item.status)
          ? executorsStat[item.status]++
          : (executorsStat[item.status] = 1);
      });
      yield put(
        executorsActions.getFilterExecutorsSuccess({
          executors: response,
          executorsStat,
        })
      );
    } catch (err) {
      yield put(executorsActions.getFilterExecutorsError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(executorsActions.getFilterExecutors(action.payload))
      : history.push('/authorization/profiles');
  }
}

export function* executorsWatcher() {
  yield takeEvery(
    executorsActions.getAllExecutors.toString(),
    getAllExecutorsSaga
  );
  yield takeEvery(
    executorsActions.getFilterExecutors.toString(),
    getFilterExecutorsSaga
  );
}
